import { ApiRequest, RequestMethod } from "../../request";

export async function deleteFighterXp(fighterId: string, eventId: string): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.DELETE);
    apiRequest.setUrl(`/api/fighter/${fighterId}/xp/${eventId}`);

    const response: any = await apiRequest.send();
    return response.status === 200;
}
